import './registerServiceWorker';
import 'babel-polyfill';
import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import {library} from '@fortawesome/fontawesome-svg-core';
import {faFilePdf, faGreaterThan} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import vuetify from './plugins/vuetify';
import store from './store';
import router from './router';
import App from './App';


// Font Awesome
library.add(faFilePdf, faGreaterThan);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;
if (process.env.VUE_APP_GOOGLE_ANALYTICS_ID) {
  Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
    router
  });
}

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount('#app');
